export default __webpack_public_path__ + "static/image/image005.a22a2285.jpg";